<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-row>
          <v-col cols="12">
            <h1 class="text-h3 mb-4">Blog</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="post in posts" :key="post.slug" cols="12" sm="6" md="4">
            <v-card :to="`/blog/${post.slug}`" hover height="100%">
              <v-img
                v-if="post.thumbnail"
                :src="post.thumbnail"
                height="200"
                cover
              ></v-img>
              <v-card-title>{{ post.title }}</v-card-title>
              <v-card-subtitle>{{ post.date }}</v-card-subtitle>
              <v-card-text>{{ post.description }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getBlogPosts } from "@/utils/blog";

export default {
  name: "BlogList",
  data() {
    return {
      posts: [],
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  created() {
    this.updatePosts();
  },
  watch: {
    language() {
      this.updatePosts();
    }
  },
  methods: {
    updatePosts() {
      this.posts = getBlogPosts(this.language);
    }
  }
};
</script>


<style scoped>
/* Reverting to simple styles */
</style>
